export default "__VITE_ASSET__C5I5SEMW__"